<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChat_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M18.286 1.027H5.714A4.715 4.715 0 0 0 1 5.741V21.47c0 .926 1.185 1.313 1.732.565l2.135-2.92a3.23 3.23 0 0 1 2.606-1.325h10.813A4.715 4.715 0 0 0 23 13.075V5.74a4.715 4.715 0 0 0-4.714-4.714m-.524 11.262H6.238v-1.571h11.524zm0-4.19H6.238V6.527h11.524z"
    />
</svg>
